import React, {useEffect, useState, ReactNode} from "react"
import {Form} from "react-final-form";
import {InfoSubmitEvent} from "../../../Containers/RootContainer";
import Grid from "@mui/material/Grid2";
import {RegisterNumberFieldSimple} from "../../RegisterNumberField";
import AcceptTermsOfServiceField from "./AcceptTermsOfServiceField";
import BackButton from "./BackButton";
import {Button} from "@mui/material";
import {a11yClick} from "../../../Utils/a11yHelpers";
import FirstNameField from "./FirstNameField";
import LastNameField from "./LastNameField";
import PhoneField from "./PhoneField";
import EmailField from "./EmailField";
import {useTranslation} from "react-i18next";

interface UserInfoFormProps {
    header: ReactNode | string
    prefill: InfoSubmitEvent
    onSubmitInfo: (info: InfoSubmitEvent) => void
    onBack: () => void
    askRegisterNumber?: boolean
    isReadyToSend: (values: InfoSubmitEvent) => boolean
    setShowPrivacyPolicy: (value: boolean) => void
    onChange: (info: InfoSubmitEvent) => void
}

const UserInfoForm = ({ header, prefill, onSubmitInfo, onBack, askRegisterNumber = false, isReadyToSend, setShowPrivacyPolicy, onChange }: UserInfoFormProps) => {
    const { t } = useTranslation()

    const [showErrors, setShowErrors] = useState<boolean>(false)

    const renderFields = () => {
        return (<>
            <Grid size={6} style={{paddingRight: '1rem'}}>
                <FirstNameField />
            </Grid>
            <Grid size={6} style={{paddingLeft: '1rem'}}>
                <LastNameField />
            </Grid>
            <Grid size={6} style={{paddingRight: '1rem'}}>
                <PhoneField />
            </Grid>
            <Grid size={6} style={{paddingLeft: '1rem'}}>
                <EmailField />
            </Grid>
        </>)
    }

    return (
        <Form
            onSubmit={(info: InfoSubmitEvent) => isReadyToSend(info) ? onSubmitInfo(info) : setShowErrors(true)}
            initialValues={{...prefill}}
        >
            {({values, handleSubmit}) => {
                useEffect(() => {
                    onChange(values as InfoSubmitEvent)
                }, [values, onChange])

                useEffect(() => {
                    if (values.acceptTermsOfUse) {
                        setShowErrors(true)
                    }
                }, [values.acceptTermsOfUse])

                return (
                    <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
                        <Grid className="pageMainHeader">
                            {header}
                        </Grid>
                        <Grid className="pageScrollContainer">
                            <Grid container spacing={4} alignItems="flex-start">
                                {askRegisterNumber &&
                                    <Grid size={12}>
                                        <RegisterNumberFieldSimple
                                            id="RegistrationNumberInput"
                                            disabled={false}
                                            textFieldProps={{
                                                className: 'registrationNumberInput',
                                                variant: 'outlined',
                                                style: {textAlign: 'start', fontFamily: 'Koulen', fontWeight: 500, lineHeight: 1.0},
                                                inputProps: {
                                                    style: {paddingLeft: '1.5rem'}
                                                },
                                            }}
                                            showClearButton
                                            scale={1.25}
                                        />
                                    </Grid>
                                }
                                {renderFields()}
                                <Grid size={12}>
                                    <AcceptTermsOfServiceField
                                        showErrors={showErrors}
                                        values={values}
                                        setShowPrivacyPolicy={setShowPrivacyPolicy}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid className="footerButtons">
                            <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                                <Grid>
                                    {onBack &&
                                        <BackButton onBack={onBack} />
                                    }
                                    {!onBack &&
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className="buttonNarrow"
                                            onClick={() => window.location.reload()}
                                        >
                                            {t('selfService.noThankYou')}
                                        </Button>
                                    }
                                </Grid>
                                <Grid>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        {...a11yClick(() => {
                                            setShowErrors(true)
                                            handleSubmit()
                                        })}
                                    >
                                        {t('common.continue')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </Form>
    )
}

export default UserInfoForm
